import {
    useContext,
    useState
} from "react";
import {
    getThemeSwitcherIconColor
} from "./stylesheet";
import {
    ThemeSwitcherIconContext
} from "./context";
import {
    NCoreUIKitTheme
} from "../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../types";
import AnimatedIcon from "../animatedIcon";

export const ThemeSwitcherTriggerIcon: NCoreUIKitIcon = ({
    customColor: buttonIconColor,
    color,
    size
}) => {
    const {
        isCustomIconColor,
        customTheme,
        isDisabled,
        variant,
        icon
    } = useContext(ThemeSwitcherIconContext);

    const {
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const [
        previousIcon,
        setPreviousIcon
    ] = useState({
        icon
    });

    const [
        isTransitioning,
        setIsTransitioning
    ] = useState(false);

    if(previousIcon.icon !== icon) {
        setPreviousIcon({
            icon
        });

        setIsTransitioning(!!icon && !!previousIcon.icon);
    }

    if(!variant) {
        return null;
    }

    const isRestNeutral = !isTransitioning && !isCustomIconColor && !isDisabled && (!variant.iconColor || variant.iconColor === "default" || variant.iconColor === "sun" || variant.iconColor === "moon");

    const iconColor = isRestNeutral ? colors.content.text.high : getThemeSwitcherIconColor({
        iconColor: variant.iconColor,
        isCustomIconColor,
        buttonIconColor,
        isDisabled,
        colors
    });

    if(!icon) {
        const VariantIcon = variant.icon;

        return <VariantIcon
            customColor={iconColor}
            color={color}
            size={size}
        />;
    }

    return <AnimatedIcon
        onTransitionEnd={() => setIsTransitioning(false)}
        customTheme={customTheme}
        customColor={iconColor}
        iconTransition="morph"
        color={color}
        size={size}
        icon={icon}
    />;
};
